import styled from "styled-components";

export const Text = styled.p<{
  fontSize?: number | string;
  fontWeight?: number | string;
  fontFamily?: string;
  $lineHeight?: string;
  color?: string;
  backgroundColour?: string;
  $mt?: number;
  $mb?: number;
  ml?: number;
  mr?: number;
  $pt?: number;
  $pb?: number;
  $pr?: number;
  $pl?: number;
  $align?: string;
  width?: string;
  $margin?: string;
  borderBottom?: string;
  fontStyle?: string;
  $justify?: string;
  $display?: string;
  $textDecoration?: string;
  $cursor?: boolean;
}>`
  display: ${({ $display }) => ($display ? `${$display}` : "flex")};
  ${({ fontFamily }) => fontFamily && `font-family: ${fontFamily};`}
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}
  ${({ $lineHeight }) => $lineHeight && `line-height: ${$lineHeight};`}
  ${({ fontSize }) =>
    fontSize &&
    `font-size: ${typeof fontSize === "number" ? `${fontSize}px` : fontSize};`}
  ${({ color }) => color && `color: ${color};`}
  ${({ backgroundColour }) =>
    backgroundColour && `background-color: ${backgroundColour};`}
  ${({ $mt }) => $mt && `margin-top: ${$mt}px;`}
  ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`}
  ${({ ml }) => ml && `margin-left: ${ml}px;`}
  ${({ mr }) => mr && `margin-right: ${mr}px;`}
  ${({ $pt }) => $pt && `padding-top: ${$pt}px;`}
  ${({ $pb }) => $pb && `padding-bottom: ${$pb}px;`}
  ${({ $pl }) => $pl && `padding-left: ${$pl}px;`}
  ${({ $pr }) => $pr && `padding-right: ${$pr}px;`}
  ${({ $align }) => $align && `text-align: ${$align};`}
  ${({ width }) => width && `width: ${width}%;`}
  ${({ $margin }) => $margin && `margin: ${$margin};`}
  ${({ borderBottom }) => borderBottom && `border-bottom: ${borderBottom};`}
  ${({ fontStyle }) => fontStyle && `font-style: ${fontStyle};`}
  ${({ $justify }) => $justify && `justify-content: ${$justify};`}
  ${({ $textDecoration }) =>
    $textDecoration && `text-decoration: ${$textDecoration};`}
  ${({ $cursor }) => $cursor && `cursor: pointer`};
`;
